export default "__VITE_ASSET__1e5b558b__"